import type { SourceDocument } from "../../../api/content/sourcesApi";
import DocumentWithAdditions from "./added/DocumentWithAdditions";
import DocumentMetadata from "./DocumentMetadata";
import DocumentParts from "./parts/DocumentParts";

interface DocumentViewProps {
  document: SourceDocument;
  /** The chosen project, whose data on the document shows; `null` shows none. */
  projectId: string | null;
}

/** One document version: its metadata, then its text once, part by part, with what the project added to it (UX-27, O-1). */
export default function DocumentView({ document, projectId }: DocumentViewProps) {
  return (
    <article className="flex-1 space-y-6 p-4">
      <DocumentMetadata metadata={document.metadata} />
      {projectId === null
        ? <DocumentParts document={document} annotations={null} evidence={null} askInProject={undefined} />
        : <DocumentWithAdditions key={projectId} projectId={projectId} document={document} />}
    </article>
  );
}
